import { MesfModal } from "@dexteel/mesf-core";
import { Button, Typography } from "@mui/material";
import type { ReactNode } from "react";

const touch = { minHeight: 56, px: 3, fontSize: 16 };

// true = confirm, false = cancel button, null = closed via X / backdrop
export const TabletConfirm = ({
	title,
	subtitle,
	message,
	confirmLabel,
	cancelLabel = "Cancel",
	confirmColor = "success",
	children,
	onClose,
}: {
	title: string;
	subtitle?: string;
	message: string;
	confirmLabel: string;
	cancelLabel?: string;
	confirmColor?: "success" | "warning" | "error" | "inherit";
	// context above the question
	children?: ReactNode;
	onClose: (confirmed: boolean | null) => void;
}) => (
	<MesfModal
		title={title}
		subtitle={subtitle}
		open
		maxWidth="sm"
		handleClose={() => onClose(null)}
	>
		{/* minWidth 0: MesfModal.Content's 600 + padding overflows the sm paper */}
		<MesfModal.Content dividers style={{ padding: "24px 30px", minWidth: 0 }}>
			{children}
			<Typography sx={{ fontSize: 20, fontWeight: children ? 600 : undefined }}>
				{message}
			</Typography>
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "16px 30px", gap: 12 }}>
			<Button
				variant="outlined"
				color="inherit"
				onClick={() => onClose(false)}
				sx={touch}
			>
				{cancelLabel}
			</Button>
			<Button
				variant="contained"
				color={confirmColor}
				onClick={() => onClose(true)}
				sx={touch}
			>
				{confirmLabel}
			</Button>
		</MesfModal.Actions>
	</MesfModal>
);
